import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  trans,
  HeaderComponent,
  ButtonComponent, InputTime,
  RefreshButton
} from "@comps/components";
import { makeRequest, removeById } from "@utils/helpers";
import { Commons, Const, colors } from "../constants";
import { message, Tooltip, Space } from 'antd';
import { ExperimentOutlined, ClockCircleOutlined, PieChartOutlined } from "@ant-design/icons"
import { FilterComponent, FilterButton, InputCheck } from "@comps/components";
import { deleteShiftAttendanceReq, getAllDataReq, getFilterReq, updateDataReq } from "./requests";
import { useSelector } from "react-redux";
import TimeSheetSummary from "./components/TimeSheetSummary";
import CreateCompanyAttendanceRequest from "../attendances/companyAttendances/components/CreateCompanyAttendanceRequest";
import CreateRelaxationRequest from "../../leaveManagement/relaxation/companyRelaxation/components/CreateRelaxationRequest";
import { convertMinutesToHours, convertTimeTotz } from '@comps/commonFunctions'
import { getDatesFilters, getOrganizationFilters, getSubordinateScopeFilters } from "../../common/commonFilterFields";
import UpdateCompanyAttendance from "./components/UpdateCompanyAttendance";
import CalculateAttendance from "./components/CalculateAttendance";
import dayjs from "dayjs";
import CreateLeaveRequest from '../../leaveManagement/leave/companyLeaves/components/CreateLeaveRequest';
import { checkPermissions } from "@comps/commonFunctions";
import UpdateTimeSlot from "../../rosterManagement/timeSlots/components/UpdateTimeSlot";
import { getAllDataReq as getTimeSlotsReq } from "../../rosterManagement/timeSlots/requests";
import { useLocation } from "react-router-dom";
// legend/badge colour classes (bg-day-off, bg-greensea, bg-tr-black, ...) live here
import "@mods/common/style.css";
import "./style.css";

const langKey = Const["myAttendance"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.companyAttendanceModule`),
    breadcrumb: [
      {
        name: trans(`${langKey}.companyAttendanceModule`),
        path: Const["myAttendance"].route
      }
    ]
  }
}

const centeredLegendStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 18,
  height: 18,
  lineHeight: "18px",
  padding: "0 5px",
  textAlign: "center",
  fontSize: 9.5,
  fontWeight: 700,
  verticalAlign: "middle",
};

const IndexCompanyTimeSheet = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [attendanceSummary, setAttendanceSummary] = useState(null)
  const [filters, setFilters] = useState('');
  const [dates, setDates] = useState()
  const [countManuallyUpdated, setCountManuallyUpdated] = useState(0)
  const [editMode, setEditMode] = useState(false);
  const [currentEmploymentId, setEmploymentId] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 32,
    sortName: "id",
    sortType: "desc",
  });

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const getStatusClass = (status) => {
    if (status === 'On Time') {
      return 'bg-success'
    }
    if (status === 'Day Off') {
      return 'bg-off'
    }
    if (status === 'Late' || status === 'Early') {
      return 'bg-warning'
    }
    if (status === 'Travel') {
      return 'bg-info'
    }
    if (status === 'Leave') {
      return 'bg-leave'
    }
    if (status === 'Absent') {
      return 'bg-absent'
    }
  }

  const getStatusText = (record, status) => {

    if (status === 'Leave') {
      return record.leave_type_name;
    }

    return status ? status : '--';

  }

  const AttendanceLegends = (attendance) => {
    let html = [];

    if (attendance.is_day_off && !attendance.is_holiday && !attendance.rest_day_id) {
      html.push(<span key="day-off" className="badge badge-single bg-day-off" style={ centeredLegendStyle }>DO</span>);
      return <>{ html }</>;
    }

    if (attendance.rest_day_id) {
      html.push(<span key="rest-day" className="badge badge-single bg-default-time-slot" style={ centeredLegendStyle }>R</span>);
    }

    if (attendance.is_holiday && !attendance.rest_day_id && checkPermissions('holiday', 'index')) {
      html.push(<span key="holiday" className="badge badge-single bg-tr-black dker" style={ centeredLegendStyle }>H</span>);
    }

    if (attendance.is_present) {
      html.push(<span key="present" className="badge badge-single bg-success" style={ centeredLegendStyle }>P</span>);
      if (attendance.is_short_duration) {
        html.push(<span key="short-duration" className="badge badge-single bg-orange" style={ centeredLegendStyle }>S</span>);
      }
    } else if (attendance.is_missing && !attendance.is_holiday) {
      html.push(<span key="missing" className="badge badge-single bg-danger" style={ centeredLegendStyle }>M</span>);
    } else if (attendance.is_absent && !attendance.is_holiday && !attendance.rest_day_id) {
      html.push(<span key="absent" className="badge badge-single bg-error dker" style={ centeredLegendStyle }>A</span>);
    }

    if (attendance.is_relaxation && checkPermissions('relaxation', 'index')) {
      html.push(<span key="relaxation" className="badge badge-single bg-informed-late" style={ centeredLegendStyle }>R</span>);
    }

    if ((attendance.is_short_official_duty || attendance.is_full_official_duty) && checkPermissions('officialDuty', 'index')) {
      html.push(<span key="official-duty" className="badge badge-single bg-darkgray" style={ centeredLegendStyle }>OD</span>);
    }

    if ((attendance.is_short_leave || attendance.is_full_leave) && checkPermissions('leave', 'index')) {
      html.push(<span key="leave" className="badge badge-single bg-greensea dker" style={ centeredLegendStyle }>L</span>);
    }

    if (attendance.is_travel && checkPermissions('travels', 'index')) {
      html.push(<span key="travel" className="badge badge-single bg-info" style={ centeredLegendStyle }>T</span>);
    }

    return <>{ html }</>;
  };

  // punch statuses come back empty for missing punches, day offs, holidays, rest
  // days, absents and leaves — fall back to the day's own state so the cell still
  // says what happened instead of showing '--'
  const getPunchState = (record, type) => {
    const status = type === 'checkin' ? record.checkin_status : record.checkout_status;
    const punchTime = type === 'checkin' ? record.checkin_punch_time : record.checkout_punch_time;

    if (record.is_day_off && !record.is_holiday && !record.rest_day_id) {
      return { label: 'Day Off', background: colors['bg-off'] };
    }

    if (record.rest_day_id) {
      return { label: 'Rest Day', background: '#5368a2' };
    }

    if (record.is_holiday) {
      return { label: record.holiday_name || status || 'Holiday', background: '#616f77' };
    }

    if ((record.is_short_leave || record.is_full_leave) && checkPermissions('leave', 'index')) {
      return {
        label: record.leave_type_name ? record.leave_type_name : 'Leave',
        background: record.leave_type_color ? record.leave_type_color : colors['bg-leave']
      };
    }

    if (record.is_absent) {
      return { label: 'Absent', background: colors['bg-absent'] };
    }

    // a working shift with no punch on this side is a missing punch, whatever the
    // backend left in the status field
    if (record.time_slot_name && !punchTime) {
      return { label: 'Missing', background: colors['bg-danger'] };
    }

    if (status) {
      const status_class = getStatusClass(status);

      return {
        label: getStatusText(record, status),
        background: record.leave_type_color ? record.leave_type_color : colors[status_class],
        color: colors[status_class + '-color'] || '#fff'
      };
    }

    return null;
  }

  const renderStatusChip = (record, type) => {
    const state = getPunchState(record, type);

    if (!state) {
      return <span className="timesheet-muted">--</span>;
    }

    return (
      <span
        className="timesheet-chip"
        style={ { background: state.background, color: state.color || '#fff' } }
      >
        { state.label }
      </span>
    );
  }

  // punch time, its expected time and the on-time/late chip share one cell so the
  // sheet fits without horizontal scrolling
  const renderTimeCell = (record, type) => {
    const isCheckin = type === 'checkin';
    const punchTime = isCheckin ? record.checkin_punch_time : record.checkout_punch_time;
    const expectedTime = isCheckin ? record.checkin_expected_time : record.checkout_expected_time;
    const time = punchTime ? convertTimeTotz(punchTime) : null;

    return (
      <div className="timesheet-time-cell">
        <InputTime defaultValue={ time } onChange={ (value) => onEditTime(record, value, type) } disabled={ !editMode } />
        <span className="timesheet-expected">
          <b>{ trans(`${langKey}.expected`) }</b>
          { convertTimeTotz(expectedTime).format('hh:mm a') }
        </span>
        { renderStatusChip(record, type) }
      </div>
    )
  }

  const formatHours = (minutes) => (minutes / 60 ? convertMinutesToHours(minutes) : '--');

  const renderDurationCell = (record) => {
    const worked = record.worked_minutes / 60 ? true : false;

    return (
      <div className="timesheet-duration-cell">
        <span className={ `timesheet-hours${worked ? "" : " is-muted"}` }>
          <em>Worked</em>{ formatHours(record.worked_minutes) }
        </span>
        <span className="timesheet-duration-meta">
          <span><b>Exp</b>{ formatHours(record.expected_minutes) }</span>
          <span><b>Break</b>{ formatHours(record.break_minutes) }</span>
        </span>
      </div>
    )
  }

  const canViewTimeSlot = checkPermissions('timeSlot', 'view');

  const columns = [
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      width: 150,
      ellipsis: false,
      render: (record) => {
        return (
          <div className="timesheet-date-cell">
            <span className="timesheet-date-legends">{ AttendanceLegends(record) }</span>
            <span className="timesheet-date-main">{ convertTimeTotz(record.date).format('dd, MMM D, YYYY') }</span>
          </div>
        )
      }
    },
    {
      key: 'time_slot_name',
      title: trans(`${langKey}.time_slot_name`),
      width: 135,
      render: (record) => {
        if (!record.time_slot_name) {
          return <span className="timesheet-muted">Shift not assigned</span>
        }

        // without the time slot permission the name stays plain text
        if (!canViewTimeSlot) {
          return <span className="timesheet-slot">{ record.time_slot_name }</span>
        }

        return (
          <Tooltip title="Click to view time slot details">
            <span className="timesheet-slot is-clickable" onClick={ () => onViewTimeSlot(record) }>
              { record.time_slot_name }
            </span>
          </Tooltip>
        )
      }
    },
    {
      key: 'checkin_punch_time',
      title: 'Check-in',
      width: 148,
      ellipsis: false,
      render: (record) => {
        return record.time_slot_name ? renderTimeCell(record, 'checkin') : renderStatusChip(record, 'checkin')
      }
    },
    {
      key: 'checkout_punch_time',
      title: 'Check-out',
      width: 148,
      ellipsis: false,
      render: (record) => {
        return record.time_slot_name ? renderTimeCell(record, 'checkout') : renderStatusChip(record, 'checkout')
      }
    },
    {
      key: 'duration',
      title: 'Duration',
      width: 150,
      ellipsis: false,
      render: (record) => renderDurationCell(record)
    },
    {
      key: 'is_manually_updated',
      title: 'Man.',
      width: 64,
      ellipsis: false,
      render: (record) => (
        <Tooltip title={ record.is_manually_updated ? 'Updated By ' + record.updated_by + ' at ' + convertTimeTotz(record.updated_at).format('DD-MM-YYYY hh:mm a') : 'Not Updated' }>
          <span className="timesheet-manual-update">
            <InputCheck checked={ record.is_manually_updated } disabled={ true } />
          </span>
        </Tooltip>
      )
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',
      width: 95,

      render: (record) => (
        <>

          {
            !props.employmentId &&
            <ActionComponent
              modkey={ props.modkey }
              each={ record }
              onEdit={ record.time_slot_name ? onEdit : '' }
              onView={ record.time_slot_name ? onView : '' }
            >
              {
                record.time_slot_name ?
                  <>
                    <Space className="timesheet-action-requests">
                      {
                        (record.is_absent || record.is_missing) && !record.is_holiday && !record.rest_day_id ?
                          <>
                            <Tooltip title="Raise relaxation request"> <ExperimentOutlined className="icon-style da-text-color-warning-1" style={ { color: "#1677ff", marginLeft: 8 } } onClick={ () => onRelaxationRequest(record) } />
                            </Tooltip>
                            <Tooltip title="Attendance Request"> <ClockCircleOutlined className="icon-style da-text-color-info-1" style={ { color: "#1677ff", marginLeft: 15 } } onClick={ () => onAttendanceRequest(record) } />
                            </Tooltip>
                          </>
                          : ''
                      }
                      {
                        record.is_absent && <Tooltip title="Raise leave request"> <PieChartOutlined className="icon-style da-text-color-warning-1" style={ { color: "#1677ff", marginLeft: 15 } } onClick={ () => onLeaveRequest(record) } />
                        </Tooltip>
                      }
                    </Space>
                  </>
                  : ''
              }
            </ActionComponent >
          }


        </>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================
  const location = useLocation();
  useEffect(() => {
    //getAllData();
    getAllRecord()
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    //getAllData();
    if (props.employmentId) {
      getAllRecord()
    }
    // eslint-disable-next-line
  }, [props.employmentId]);
  // first load with nothing applied: default to the logged-in employment and the
  // current month instead of forcing the user through the filter drawer
  const getDefaultFilters = () => {
    const from = dayjs().startOf('month').format('YYYY-MM-DD');
    const to = dayjs().endOf('month').format('YYYY-MM-DD');
    // my-attendance / employee tabs already carry the employee in props.filters, and
    // the subordinate screen is scoped to other employments
    const employee = props.module === 'company-attendance' && !props.employmentId && authUser && authUser.employment_id
      ? `employee_|${authUser.employment_id};`
      : '';

    return `${employee}from_|${from};to_|${to};`;
  }

  const getAllRecord = () => {
    setAttendanceSummary(null)
    setDataSource([])

    const selected = filters ? filters : getDefaultFilters();
    setFilters(selected)
    getAllData(selected)
  }
  const getAllData = (fil) => {

    //setAttendanceSummary(null)
    setDataSource([])
    setChildComponent(null)
    const payload = {
      page: 1,
      filters: `${props.filters};${fil}`
    }

    if (props.module !== 'my-attendance' && !fil) {
      onOpenFilter()
    }
    else {
      makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
    }

  };

  const onSuccess = (response) => {
    let employee = null
    let dates = {}
    let manullayCount = [];
    if (response.attendances.length > 0) {
      setEmploymentId(response.attendances[0].employment_id)
      manullayCount = response.attendances.filter(attendance => attendance.is_manually_updated)
      employee = response.attendances[0].employee_name
      dates = {
        from: response.attendances[0].date,
        end: response.attendances[response.attendances.length - 1].date
      }
    }
    setCountManuallyUpdated(manullayCount.length)
    setDataSource(response.attendances);

    setDates(dates)
    setAttendanceSummary(<TimeSheetSummary attendanceSummary={ attendanceSummary } manuallyUpdatedCount={ manullayCount.length } record={ response.summary } employee={ employee } dates={ dates } />)
    onCloseFilter()
  };

  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(
      <UpdateCompanyAttendance onCompleted={ onCompleted } record={ record } disabled={ false } getAllData={ getAllData } authUser={ authUser } filters={ filters } />
    );
  };
  const onEditTime = (record, value, col) => {

    let checkin_time = record.checkin_punch_time;
    let checkout_time = record.checkout_punch_time;
    if (col === 'checkin') {
      checkin_time = value ? value.second(0) : null;
      checkout_time = record.checkout_punch_time ? convertTimeTotz(record.checkout_punch_time).second(0) : null;
    }
    if (col === 'checkout') {
      checkin_time = record.checkin_punch_time ? convertTimeTotz(record.checkin_punch_time).second(0) : null;
      checkout_time = value ? value.second(0) : null;
    }
    const payload = {
      filters: `${props.filters};${filters}`,
      id: record.id,
      attendance: {
        ...record,
        checkin_time: checkin_time,
        checkout_time: checkout_time,
        checkin_date: checkin_time ? dayjs(record.checkin_expected_time).format('YYYY-MM-DD') : null,
        checkout_date: checkout_time ? dayjs(record.checkout_expected_time).format('YYYY-MM-DD') : null,
        checkin_punch_time: checkin_time,
        checkout_punch_time: checkout_time,
        is_manually_updated: true,
      }
    }
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }
  const onError = (err, res) => {
    message.error(res.response.data.message);
  }
  // the timesheet row only carries the slot name, so pull the full slot (with its
  // breaks) by name before opening the read-only time slot modal
  const onViewTimeSlot = (record) => {
    const payload = {
      page: 1,
      filters: `name_|${record.time_slot_name};`
    }
    makeRequest(setLoader, getTimeSlotsReq, payload, (response) => onTimeSlotLoaded(response, record), onError);
  };

  const onTimeSlotLoaded = (response, record) => {
    const timeSlots = response && response.time_slots && response.time_slots.data ? response.time_slots.data : [];
    const timeSlot = timeSlots.find((each) => each.name === record.time_slot_name);

    if (!timeSlot) {
      message.error('Time slot details not found');
      return;
    }

    setChildComponent(
      <UpdateTimeSlot record={ timeSlot } disabled={ true } onCreated={ () => setChildComponent(null) } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateCompanyAttendance onCompleted={ onCompleted } record={ record } disabled={ true } getAllData={ getAllData } authUser={ authUser } filters={ filters } />
    );
  };
  const onAttendanceRequest = (record) => {
    setChildComponent(
      <CreateCompanyAttendanceRequest onCompleted={ onCompleted } record={ record } employment_id={ currentEmploymentId } authUser={ authUser } source={ 'timeSheet' } />
    );
  };
  const onRelaxationRequest = (record) => {
    setChildComponent(
      <CreateRelaxationRequest onCompleted={ onCompleted } record={ record } employment_id={ currentEmploymentId } authUser={ authUser } source={ 'timeSheet' } />
    );
  };
  const onLeaveRequest = (record) => {
    setChildComponent(
      <CreateLeaveRequest onCompleted={ onCompleted } record={ record } employment_id={ currentEmploymentId } authUser={ authUser } source={ 'timeSheet' } />
    );
  };

  const onDelete = (record) => {
    let payload = {
      id: record.id
    }
    makeRequest(setLoader, deleteShiftAttendanceReq, payload, onDeleted, null);
  }
  const onDeleted = (res) => {

    const data = removeById(dataSource, res.id);
    setDataSource(data);
  }
  const onCompleted = (response) => {
    if (response.attendances !== undefined) {
      getAllData(filters)
      // setDataSource(response.attendances);
      // const dates = {
      //   from: response.attendances[0].date,
      //   end: response.attendances[response.attendances.length - 1].date
      // }
      // setAttendanceSummary(null)
      // setAttendanceSummary(
      //   <TimeSheetSummary record={ response.summary } employee={ authUser } dates={ dates } />
      // )
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } optionScopeFilters={ getSubordinateScopeFilters(props.filters) } onFilter={ onApplyFilter } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);
  }
  const onApplyFilter = (filters) => {
    setFilters(filters)
    getAllData(filters)
    setChildComponent(null);
  }

  //----end filter--------------------
  //calculate attendance by date ,employee,department
  const onCalculateAttendance = (data) => {
    setChildComponent(<CalculateAttendance onCompleted={ onCompleted } />)
  }

  //filter fields

  const filterArray = props.module === 'my-attendance' ? [] : getOrganizationFilters('')
  if (props.module !== 'my-attendance') {
    filterArray.unshift({
      type: "select",
      placeholder: 'Employee',
      key: "employee",
      data_key: "supporting_data.employments",
      required: true,
      employeeType: props.module === 'subordinate-attendance' ? 'subordinate' : 'all',
      subordinates: props.module === 'subordinate-attendance' ? true : false,
      resource_type: 'employment'
      //is_resource: true
    })

  }

  filterArray.push({
    type: "select",
    placeholder: 'Attendance Status',
    key: "attendance_status",
    data_key: "supporting_data.attendance_status",
    multiple: false
  })

  const filterFields = filterArray.concat(getDatesFilters(''))

  return (
    <>

      { childComponent }
      <BodyComponent className="company-timesheet-page">
        <HeaderComponent className="time-sheet-header" headers={ pageConfig.headers } modkey={ props.modkey }>
          { dataSource.length > 0 && props.module !== 'my-attendance' && props.module !== "subordinate-attendance" && checkPermissions('companyAttendance', 'update') && <ButtonComponent text={ editMode ? "Disable Edit" : "Enable Edit" } onClick={ () => setEditMode(!editMode) } /> }
          { <ButtonComponent text='Calculate' type='primary' onClick={ () => onCalculateAttendance() } /> }
          <RefreshButton onClick={ () => getAllData(filters) } />
          <FilterButton onClick={ () => onOpenFilter() } />
        </HeaderComponent>
        { attendanceSummary }

        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          containerClassName="company-timesheet-table"
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
          key={ editMode }
        />


      </BodyComponent>
    </>
  );


};





export default IndexCompanyTimeSheet;
